import { useRef } from 'react';
import { useDropzone } from 'react-dropzone';

import { AhuaIcon, Title, Button } from '@yaradigitallabs/ahua-react';

import { fileUploadText } from './bulkImportConstants';
import MaxFileLimitReachedPopOver from './MaxFileReachedPopOver';

const BulkFileUploader = ({ file, onHandleFileChange }) => {
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const onDrop = (files: File[]) => {
    const file = files[0];

    if (!file) return;

    const reader = new FileReader();
    onHandleFileChange(file, 0);

    reader.onprogress = event => {
      if (event.lengthComputable) {
        const progress = Math.round((event.loaded / event.total) * 100);
        onHandleFileChange(file, progress);
      }
    };

    reader.onload = async () => {
      onHandleFileChange(file, 100);

      // File has now been completely read
      // Start API upload here
      //await uploadFile(file);
    };

    reader.onerror = () => {
      onHandleFileChange(file, 0);
    };

    reader.readAsArrayBuffer(file);
  };

  const handleSelectFile = () => {
    if (file) {
      fileInputRef.current?.click();
    }
    open();
  };

  const { getRootProps, getInputProps, open } = useDropzone({
    onDrop,
    maxFiles: 1,
    multiple: false,
    noClick: true,
    noKeyboard: true,
    accept: {
      'text/csv': ['.csv'],
    },
  });

  return (
    <div className="rounded-xl border border-gray-200 bg-gray-50 p-3 m-2">
      <div
        {...getRootProps({
          onDrop: event => {
            if (file) {
              event.preventDefault();
              event.stopPropagation();
            }
          },
        })}
        className="flex flex-col items-center justify-center border-0 outline-none cursor-pointer"
      >
        <input {...getInputProps()} />
        <div className="flex flex-col items-center justify-center mb-2 mt-4">
          <AhuaIcon icon="Upload" size="xl" colorConcept="brand" />
        </div>
        {file ? (
          <p className="flex flex-col items-center justify-center text-gray-500 font-medium mb-2">
            {fileUploadText.MAX_FILE_LIMIT_INFO}
          </p>
        ) : (
          <div className="flex flex-col items-center justify-center mb-2">
            <Title maxLineCount={1} size="s" css={{ marginBottom: '15px' }}>
              {fileUploadText.TITLE}
            </Title>
            <div className="text-gray-500 font-medium ">
              {fileUploadText.SUBTITLE}
            </div>
            <div className="text-gray-500 font-medium mb-2">
              {fileUploadText.MAX_FILE_LIMIT_INFO}
            </div>
          </div>
        )}
      </div>
      <div className="group relative flex flex-col items-center justify-center mb-8">
        <input
          ref={fileInputRef}
          type="file"
          multiple
          style={{ display: 'none' }}
          id="fileInput"
          className="hidden"
        />
        <Button
          colorConcept={file ? 'neutral' : 'brand'}
          size="n"
          variant="secondary"
          onClick={handleSelectFile}
          disabled={file}
          className="
                    text-gray-700 
                    disabled:!cursor-not-allowed 
                    disabled:[&_span]:cursor-not-allowed
                    disabled:!pointer-events-none"
        >
          {fileUploadText.SELECT_FILE_BUTTON_TEXT}
        </Button>
        <MaxFileLimitReachedPopOver file={file} />
      </div>
    </div>
  );
};

export default BulkFileUploader;
